import { useConfigStore } from '@/store/ConfigStore';

export const Logo = () => {
  const config = useConfigStore((state) => state.config);

  if (config?.logo) {
    const currentUrlWithoutSearchParams = window.location.href.split('?')[0];
    return (
      <a href={currentUrlWithoutSearchParams} className="flex items-center">
        <img
          src={config.logo}
          alt="logo"
          className="h-auto w-40 dark:brightness-0 dark:invert dark:filter print:!invert-0"
        />
      </a>
    );
  }

  return null;
};
